interface IConfig {
  token: string;
  chatId: string;
  phoneNumber: string;
  adressLabel: string;
  adressLink: string;
}

const config:IConfig = {
  token: '7452433202:AAGubLRFXtZC8GIAl_RKKLmndrjBvIw2Z8s',
  chatId: '-1002233704591',
  phoneNumber: '+48 786 887 050',
  adressLabel: 'Poczty gdańskiej 17, 02-495 Warszawa, Poland',
  adressLink: 'https://maps.app.goo.gl/8cYfDjd5Tg9f1U3s8',
};


export default config;
